import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
// dashbourd
import Dashbourd from "../Pages/Dashbourd/dashbourd";
// internal
import EmployeeManagement from "../Pages/Internal/employee_management";
import EmployeeLeaveManagement from "../Pages/Internal/employee_leave_management";
import EmployeeDocuments from "../Pages/Internal/employee_documents";
import EmployeeAttendance from "../Pages/Internal/employee_attendance";
// quotation
import StandardQuotation from "../Pages/Quatation/standard_quotation";
import CustomQuotation from "../Pages/Quatation/custom_quotation";
import ClientDemoPlanning from "../Pages/Quatation/client_demo_planning";
// sales
import AllLeads from "../Pages/Sales/all_leads";
import IncentiveManagement from "../Pages/Sales/incentive_management";
// client
import ClientSiteInspection from "../Pages/Client Management/client_site_inspection";
import ClientProjectHandover from "../Pages/Client Management/client_project_handover";
import ClientProjectTracking from "../Pages/Client Management/client_project_tracking";
import ClientPaymentTracking from "../Pages/Accounts/client_payment_tracking";
import ClientExpenceTracking from "../Pages//Accounts/client_expence_tracking";
// farm
import FarmNurseryManagement from "../Pages/Farm Management/farm_nursery_management";
import FarmWaterManagement from "../Pages/Farm Management/farm_water_management";
import FarmOperationsManagement from "../Pages/Farm Management/farm_operations_management";
import FarmHarvestManagement from "../Pages/Farm Management/farm_harvest_management";
// workforce
import ClientEmployeeDatabase from "../Pages/Workforce/client_employee_database";
// buyers
import BuyersManagement from "../Pages/Buyers/buyers_management";
import BuyersPriceWatcher from "../Pages/Buyers/buyers_price_watcher";
import PriceWatcherScrapper from "../Pages/Buyers/price_watcher_scrapper";
import ViewPriceWatcherScrapper from "../Pages/Buyers/Price Watcher Scrapper/view_price_scrapper";
// purchase
import PurchaseContractManagement from "../Pages/Purchase/purchase_contract_management";
import PurchaseOrder from "../Pages/Purchase/purchase_order";
import PurchaseProjectSpecification from "../Pages/Purchase/purchase_project_specification";
import PurchaseVendorManagement from "../Pages/Purchase/purchase_vendor_management";
// agronomy
import AgronomyClientManagement from "../Pages/Agronomy/agronomy_client_management";
import AgronomyPlantsWiki from "../Pages/Agronomy/agronomy_plants_wiki";
// resources
import ResourcesAssets from "../Pages/Resources/resources_assets";
import ResourcesInventory from "../Pages/Resources/resources_inventory";
// user
import UserAccountSetting from "../Pages/User/user_account_setting";
import UserLogin from "../Pages/User/user_login";
import ForgetPassword from "../Pages/User/forget_password";
import ResetPassword from "../Pages/User/reset_password";
// employee sub-page
import AddEmployee from "../Pages/Internal/Employee Managemennt/add_employee";
import ViewEmployee from "../Pages/Internal/Employee Managemennt/view_employee";
import EditEmployee from "../Pages/Internal/Employee Managemennt/edit_employee";
// employee leaves sub-page
import AddEmployeeLeves from "../Pages/Internal/Employee Leave Management/add_leaves";
import EditLeaves from "../Pages/Internal/Employee Leave Management/edit_leaves";

// custom quotation sub route
import AddQuotation from "../Pages/Quatation/CustomQuatation/add_quotation";
import QuotationPreview from "../Pages/Quatation/CustomQuatation/view_quotation";
import EditQuotation from "../Pages/Quatation/CustomQuatation/edit_quotation";
// quotation matrix sub-route

// leads sub-route
import AddLeads from "../Pages/Sales/Leads/add_leads";
import EditLeads from "../Pages/Sales/Leads/edit_leads";
import ViewLeads from "../Pages/Sales/Leads/view_leads";
// vendor sub-route
import AddVendor from "../Pages/Purchase/Vendor Management/add_vendor";
import EditVendor from "../Pages/Purchase/Vendor Management/edit_vendor";
import ViewVendor from "../Pages/Purchase/Vendor Management/view_vendor";
// purchase order sub-route
import AddPurchaseOrder from "../Pages/Purchase/Purchase Order/add_purchase_order";
import EditPurchaseOrder from "../Pages/Purchase/Purchase Order/edit_purchase_order";
import ViewPurchaseOrder from "../Pages/Purchase/Purchase Order/view_purchase_order";
import PreviewPurchaseOrder from "../Pages/Purchase/Purchase Order/preview_purchase_order";
// delivery challan sub-route
import DeliveryChallan from "../Pages/Purchase/delivery_challan";
import AddDeliveyChallan from "../Pages/Purchase/Delivery Challan/add_delivey_challan";
import EditDeliveyChallan from "../Pages/Purchase/Delivery Challan/edit_delivery_challan";
import ViewDeliveryChallan from "../Pages/Purchase/Delivery Challan/view_delivery_challan";
import PreviewDeliveryChallan from "../Pages/Purchase/Delivery Challan/preview_delivery_challan";
import ClientProject from "../Pages/Client Management/client_projects";
import AddClientProject from "../Pages/Client Management/Client Projects/add_client_project";
import ViewClientProject from "../Pages/Client Management/Client Projects/view_client_project";
import EditClientProject from "../Pages/Client Management/Client Projects/edit_client_project";
import AddSiteInspection from "../Pages/Client Management/Site Inspection/add_site_inspection";
import EditClientSiteInspection from "../Pages/Client Management/Site Inspection/edit_site_inspection";
import ViewSiteInspection from "../Pages/Client Management/Site Inspection/view_site_inspection";
import SiteInspectionPreview from "../Pages/Client Management/Site Inspection/preview_site_inspection";
import AddProjectTracking from "../Pages/Client Management/Project Tracking/add_project_tracking";
import EditProjectTracking from "../Pages/Client Management/Project Tracking/edit_project_tracking";
import ViewProjectTracking from "../Pages/Client Management/Project Tracking/view_project_tracking";
import AddExpense from "../Pages/Accounts/Expense Tracking/add_expense";
import ViewExpenseTracking from "../Pages/Accounts/Expense Tracking/view_expense_tracking";
import EditExpenseTracking from "../Pages/Accounts/Expense Tracking/edit_expense_tracking";
import Enquiry from "../Pages/Sales/enquiry";
import ViewBuyer from "../Pages/Buyers/Buyers Management/view_buyer";
import InternalFAQ from "../Pages/Internal/internal_faq";
import EditPaymentTracking from "../Pages/Accounts/Payment Tracking/edit_payment_tracking";
import ViewPaymentTracking from "../Pages/Accounts/Payment Tracking/view_payment_tracking";
import AddPaymentTracking from "../Pages/Accounts/Payment Tracking/add_payment_tracking";
import EditProjectHandover from "../Pages/Client Management/Client Handover/edit_handover";
import AddProjectHandover from "../Pages/Client Management/Client Handover/add_handover";
import ViewHandover from "../Pages/Client Management/Client Handover/view_handover";
import ClientFeedback from "../Pages/Client Management/client_feedback";
import AddClientFeedback from "../Pages/Client Management/Client Feedback/add_client_feedback";
import AddIncentive from "../Pages/Sales/Incentive/add_incentive";
import EditIncentive from "../Pages/Sales/Incentive/edit_incentive";
import AddProjectSpecification from "../Pages/Purchase/Project Specification/add_project_specification";
import EditProjectSpecification from "../Pages/Purchase/Project Specification/edit_project_specification";
import ViewProjectSpecification from "../Pages/Purchase/Project Specification/view_project_specification";
import PreviewSpecification from "../Pages/Purchase/Project Specification/preview_specification";
import LeadsTracking from "../Pages/Sales/leads_tracking";
import FarmConstructionAgreement from "../Pages/Farm Management/farm_construction_agreement";
import FarmAgreement from "../Pages/Farm Management/Farm Agreement/farm_agreement";
import Quotation from "../Pages/Farm Management/Farm Agreement/quotation";
import ReimbursementManagement from "../Pages/Internal/reimbursement";
import AddReimbursement from "../Pages/Internal/Reimbursement/add_reimbursement";
import EditReimbursement from "../Pages/Internal/Reimbursement/edit_reimbursement";
import Attendance from "../Pages/User/attendance";
import CallRecords from "../Pages/Sales/call_records";
import ViewAttendance from "../Pages/Internal/Employee Attendance/view_attendance";
import ViewLeaves from "../Pages/Internal/Employee Leave Management/view_leaves";
import AddWorkforce from "../Pages/Workforce/Workforce Management/add_workforce";
import EditWorkforce from "../Pages/Workforce/Workforce Management/edit_workforce";
import ViewWorkforce from "../Pages/Workforce/Workforce Management/view_workforce";
import AddAssets from "../Pages/Resources/Assets Tracking/add_assets";
import EditAssets from "../Pages/Resources/Assets Tracking/edit_assets";
import ViewAssets from "../Pages/Resources/Assets Tracking/view_assets";
import EditInventory from "../Pages/Resources/Inventory Tracking/edit_inventory";
import ViewInventory from "../Pages/Resources/Inventory Tracking/view_inventory";
import AddInventory from "../Pages/Resources/Inventory Tracking/add_inventory";
import LeadsFollowup from "../Pages/Sales/leads-followup";
import PrivateRoutes from "./privateRoutes";
import Home from "../Pages Without Login/home";
import SIFeedback from "../Pages Without Login/si_feedback";
import ViewQuotationMatrix from "../Pages/Quatation/Quotation Matrix/view_quotation_matrix";
import EditQuotationMatrix from "../Pages/Quatation/Quotation Matrix/edit_quotation_matrix";
import LeadsFiltered from "../Pages/Sales/leads_filtered";
import AddAgronomyWiki from "../Pages/Agronomy/Agronomy Wiki/add_agronomywiki";
import ViewAgronomyWiki from "../Pages/Agronomy/Agronomy Wiki/view_agronomywiki";
import EditAgronomyWiki from "../Pages/Agronomy/Agronomy Wiki/edit_agronomywiki";
import AddBuyer from "../Pages/Buyers/Buyers Management/add_buyer";
import AddFarmQuery from "../Pages/Agronomy/Farm Support/add_query";
import ViewQuery from "../Pages/Agronomy/Farm Support/view_query";
import SiteInspectionAll from "../Pages Without Login/SI-Feedback/standard_feedback";
import ViewSiteInsppectionFeedback from "../Pages Without Login/SI-Feedback/view_si_feedback";

import AddClientInvoice from "../Pages/Accounts/Client Invoice/add_client_invoice";
import EditClientInvoice from "../Pages/Accounts/Client Invoice/edit_client_invoice";
import ViewClientInvoice from "../Pages/Accounts/Client Invoice/view_client_invoice";
import PreviewClientInvoice from "../Pages/Accounts/Client Invoice/preview_client_invoice";
import ClientInvoice from "../Pages/Accounts/client_invoice";
import ColdLeadsTracking from "../Pages/Sales/cold_leads";
import AttendanceLogout from "../Pages/User/attendance_logout";
import AddFarmTraining from "../Pages/Sales/Farm Training/add_farm_training";
import EditFarmTraining from "../Pages/Sales/Farm Training/edit_farm_training";
import ViewFarmTraining from "../Pages/Sales/Farm Training/view_farm_training";
import FarmTraining from "../Pages/Sales/farm_training";
import KryzenDashBoard from "../Pages/Dashbourd/kryzen_dashboard";
import NutrientCalculations from "../Pages/Farm Management/nutrient_calculations";
import CreateWaterCycle from "../Pages/Farm Management/Water Management/create_water_cycle";
import EditWaterCycle from "../Pages/Farm Management/Water Management/edit_water_cycle";
import ViewWaterManagement from "../Pages/Farm Management/Water Management/view_water_cycle";
import AddBatch from "../Pages/Farm Management/Nursery Management/add_batch";
import ViewBatch from "../Pages/Farm Management/Nursery Management/view_batch";
import EditBatch from "../Pages/Farm Management/Nursery Management/edit_batch";
import EditBuyer from "../Pages/Buyers/Buyers Management/edit_buyer";
import CreateCampaign from "../Pages/Internal/Marketing List/create_campaign";
import MarketingSystem from "../Pages/Internal/marketing_system";
import CreateTask from "../Pages/Internal/Task Management/create_task";
import EditTask from "../Pages/Internal/Task Management/edit_task";
import ViewTasks from "../Pages/Internal/Task Management/view_task";
import TaskManagement from "../Pages/Internal/task_management";
import AddPriceWatcher from "../Pages/Buyers/Price Watcher/add_price_watcher";
import ViewPriceWatcher from "../Pages/Buyers/Price Watcher/view_price_watcher";
import EditPriceWatcher from "../Pages/Buyers/Price Watcher/edit_price_watcher";
import TermsAndConditions from "../Pages Without Login/terms_&_conditions";
import ContactUs from "../Pages Without Login/contact_us";
import PrivacyPolicy from "../Pages Without Login/privacy_policy";
import ResearchRnn from "../Pages/Buyers/Price watcher components/research_rnn";
import MobileApp from "../Pages/Internal/mobile_app";
import ViewMobileApp from "../Pages/Internal/Mobile App/view_mobile_data";
import WatsappLog from "../Pages/Internal/watsapp_log";
import ViewWatsappLog from "../Pages/Internal/Watsapp Logs/view_watsapp_log";
import CreateSiteInspection from "../Pages/Client Management/SI Client Role/create_site_inspection";
import ClientSiteInspectionRole from "../Pages/Client Management/SI Client Role/site_insp";
import ViewSI from "../Pages/Client Management/SI Client Role/view_si";
import PreviewSI from "../Pages/Client Management/SI Client Role/preview_si";
import EditSI from "../Pages/Client Management/SI Client Role/edit_si";
import Longtermcontract from "../Pages/Buyers/Longtermcontract";
import SalesDashboard from "../Pages/Sales/Sales Analysis/sales_analysis";
import SalesUpdates from "../Pages/Sales/sales_updates";
import HarvestCreate from "../Pages/Farm Management/Harvest Management/create_harvest_date";
import HarvestView from "../Pages/Farm Management/Harvest Management/view_harvest";
import HarvestEdit from "../Pages/Farm Management/Harvest Management/edit_harvest";
import CropUpdate from "../Pages/Farm Management/crop_update";
import CreateCropUpdate from "../Pages/Farm Management/Crop Updates/create_crop_update";
import EditCropUpdate from "../Pages/Farm Management/Crop Updates/edit_crop_update";
import ViewCropUpdate from "../Pages/Farm Management/Crop Updates/view_crop_update";
import AddPestDisease from "../Pages/Agronomy/Pest Diseases/create_pest_disease";
import EditPestDisease from "../Pages/Agronomy/Pest Diseases/edit_pest_disease";
import ViewPestDisease from "../Pages/Agronomy/Pest Diseases/view_pest_disease";
import PestDisease from "../Pages/Agronomy/pest_disease";
import OnboardhydroBuild from "../Pages/Onboard hydroBuild/onboard_hydroBuild";
import OnboardhydroBuildMain from "../Pages/Onboard hydroBuild/onboard_hydrobuild_main";
import HydrobuildLogs from "../Pages/Onboard hydroBuild/hydrobuild_logs";
import Webinarhomepage from "../Pages/webinar/webinar_homepage";
import EmployeeSalary from "../Pages/Internal/Employee Salary/employe_salary";
import PreviewPayslips from "../Pages/Internal/Employee Salary/preview_payslips";
import MaterialPlanning from "../Pages/Internal/material_planning";
import ViewMaterial from "../Pages/Internal/Material Planning/view_material";
import EditMaterial from "../Pages/Internal/Material Planning/edit_material";
import HydroponicMaterialPlanning from "../Pages/Internal/hydroponic_material_planning";
import HydroponicMaterialTable from "../Pages/Internal/Hydroponic Material Planning/hydroponic_material_table";
import FarmerInventory from "../Pages/Farm Management/farm_plants_inventory";
import FarmerInventoryView from "../Pages/Farm Management/Plants Inventory/view_plants_inventory";
import FarmerShop from "../Pages/Farm Management/farm_shop";
import FarmerOrders from "../Pages/Farm Management/farm_order";
import FarmerOrderView from "../Pages/Farm Management/Farm Orders/farm_order_view";
import CnFPlantInventoryView from "../Pages/Farm Management/CnF Inventory/cnf_plant_inventory_view";
import CnFInventory from "../Pages/Farm Management/cnf_inventory";
import CnfShop from "../Pages/Farm Management/cnf_shop";
import CnFOrders from "../Pages/Farm Management/cnf_order";
import CnfOrderView from "../Pages/Farm Management/CnF Orders/cnf_order_view";
import SubsidyDocuments from "../Pages/Client Management/subsidy_documents";
import ViewSubsidyDocuments from "../Pages/Client Management/Subsidy Documents/subsidy_documents_view";
import Addaddress from "../Pages/Farm Management/add_address";
import OrdersTally from "../Pages/Farm Management/orders_tally";
import OrdersRevenue from "../Pages/Farm Management/orders_revenue";
import Paymentsuccess from "../Pages/webinar/webinar purchase/payment_success";
import Paymentfailure from "../Pages/webinar/webinar purchase/payment_failure";
import EnquiryForm from "../Pages/Enquiry/enquiry";
import KryzenOrders from "../Pages/Farm Management/kryzen_order";
import KryzenOrderView from "../Pages/Farm Management/Kryzen Orders/kryzen_order_view";
import Emailmarketing from "../Pages/Internal/Email Marketing/email_marketing";
import Editemailtemplate from "../Pages/Internal/Email Marketing/edit_email_template";
import Createemailtemplate from "../Pages/Internal/Email Marketing/create_email_template";
import Sendbulktemplatemails from "../Pages/Internal/Email Marketing/send_mail";
import UnsubscribeMail from "../Pages/Internal/Email Marketing/unsubscribe";
import HydroponicInventory from "../Pages/Internal/hydroponic_material_inventory";
import ViewMarketingClient from "../Pages/Internal/Marketing List/view_marketing_client";
import WarrantyPdfPage from "../Pages/Quatation/PdfQuotationsTables/warranty_pdf_page";
import Pricing from "../Pages Without Login/pricing";
import EmployeeManagementLeftEmployee from "../Pages/Internal/employee_left_management";
//-------------------------Employee Feedback-----------------------------------------
import AddEmployeeFeedback from "../Pages/Feedback/add_employee_feedback";
import ViewEmployeeFeedback from "../Pages/Feedback/view_employee_feedback";
import ShowFeedback from "../Pages/Feedback/show_feedback";

import AddSiUpdates from "../Pages/SI Updates/add_si_updates";
import SiUpdates from "../Pages/SI Updates/si_updates";
import ViewSiUpdates from "../Pages/SI Updates/view_si_updates";
import EditSIUpdate from "../Pages/SI Updates/edit_si_updates";
import OfferLetter from "../Pages/Internal/Offer Letter/offer_letter";
import EEP from "../Pages/Internal/employee_eficiency_program";
import PublicQuotation from "../Pages/Quatation/CustomQuatation/public_quotation";
import EmailAnlaytics from "../Pages/Internal/Email Marketing/email_anlaytics";
import AddHMInvetory from "../Pages/Internal/Hydroponic Material Planning/add_inventory";
import EditHMInentory from "../Pages/Internal/Hydroponic Material Planning/edit_inventory";
import ReqRefund from "../Pages Without Login/reqRefund";
import UpdatePassword from "../Pages/User/update_password";
import Refund from "../Pages/Sales/refund";
import ViewRefund from "../Pages/Sales/Refund/view_refund";
import ExpiredlinkPage from "../Pages/User/expired_link_page";
import EmailMatrics from "../Pages/Internal/Email Matrics/email_matrics";
import SIschedulesByClient from "../Pages Without Login/si_schedule_by_client";
import ViewSiSchedules from "../Pages/Sales/SI Schedules/view_si_schedules";
import SiSchedules from "../Pages/Sales/SI Schedules/si_schedules";

import CricketStartPage from "../Pages/Cricket Game/cricket_start_page";
import ShowteamPage from "../Pages/Cricket Game/show_team_page";
import ViewcricketMatch from "../Pages/Cricket Game/view_cricket_match";
import ADDRFQ from "../Pages/Purchase/Request For Quotation/add_rfq";
import EditRFQ from "../Pages/Purchase/Request For Quotation/edit_rfq";
import ViewRFQ from "../Pages/Purchase/Request For Quotation/view_rfq";
import RFQ from "../Pages/Purchase/request_for_quotation";
import PreviewRFQ from "../Pages/Purchase/Request For Quotation/preview_rfq";
import AddFollowers from "../Pages/Followers Pages/add_followers";
import EditSiSchedules from "../Pages/Sales/SI Schedules/edit_si_schedules";
import CreateSiSchedules from "../Pages/Sales/SI Schedules/create_si_schedules";
import SIschedulesBySales from "../Pages/Sales/SI Schedules/si_schedules_by_sales";
import SiteInspectionPreviewAIF from "../Pages/Client Management/Site Inspection/preview_site_inspection_aif";
import CreateOrder from "../Pages/Sales/SI Schedules/create_order";
import EditSIschedulesByClient from "../Pages Without Login/edit_si_schedule_by_client";
import EditSIschedulesBySales from "../Pages/Sales/SI Schedules/edit_si_schedule_by_sales";
import CancelSiSchedules from "../Pages Without Login/cancel_si_schedule_by_client";
import AllEmployeeSalary from "../Pages/Internal/Employee Salary/all_employee_salary";
import AddEstimate from "../Pages/Accounts/Estimate/add_estimate";
import Estimate from "../Pages/Accounts/estimate";
import ViewEstimate from "../Pages/Accounts/Estimate/view_estimate";
import EditEstimate from "../Pages/Accounts/Estimate/edit_estimate";
import PreviewEstimate from "../Pages/Accounts/Estimate/preview_estimate";
import CreditNotes from "../Pages/Accounts/credit_note";
import ViewCreditNotes from "../Pages/Accounts/Credit Note/view_credit_note";
import FeatureDocs from "../Pages/Documentation/featureDocs";
import AddFeature from "../Pages/Documentation/featureDocs/addFeature";
import EditFeature from "../Pages/Documentation/featureDocs/editFeature";
import ViewFeature from "../Pages/Documentation/featureDocs/viewFeature";
import CompleteProjects from "../Pages/Client Management/complete_projects";
import ViewComplatedprojects from "../Pages/Client Management/Completed Projects/view_complated_projects";
import LiveStreamPage from "../Pages/webinar/aws_webinar";
import AllWebinarPayments from "../Pages/webinar/all_webinar_payment";
import AllWebinars from "../Pages/webinar/all_webinar";
import WebinarNewForm from "../Pages/webinar/webinar_new_form";
import CreateWebinar from "../Pages/webinar/webinars/create_webinar";
import EditWebinar from "../Pages/webinar/webinars/edit_webinar";
import ViewWebinar from "../Pages/webinar/webinars/view_webinar";
import ViewWebinarFeedbacks from "../Pages/webinar/webinar feedback/view_webinar_feedbacks";
import CreateWebinarFeedback from "../Pages/webinar/webinar feedback/create_webinar_feedback";
import ShowWebinarFeedback from "../Pages/webinar/webinar feedback/show_webinar_feedback";
import Barchart from "../Pages/Sales/Revenue Graphs/barchart";
import MonthlyRevenue from "../Pages/Sales/Revenue Graphs/barchartMon";
import Allgraphs from "../Pages/Sales/all_graphs";
import WeeklyRevenuePaiChart from "../Pages/Sales/Revenue Graphs/paichart";
import StepGraph from "../Pages/Sales/Revenue Graphs/stepGraph";
import ViewWebinarChat from "../Pages/webinar/webinar chat/viewWebinarChat";
import ShowWebinarChats from "../Pages/webinar/webinar chat/show_webinarChat";
import CallTracking from "../Pages/Sales/callTracking";
import FarmLabourTrainning from "../Pages/Farm Management/farm-labour-trainning";
import AddLabourTrainning from "../Pages/Farm Management/FarmLabourTrainning/addLabourTrainning";
import EditLabourTraningSchedule from "../Pages/Farm Management/FarmLabourTrainning/labourTraninigUpdate";
import ViewSchedule from "../Pages/Farm Management/FarmLabourTrainning/viewLabourSchedule";
import ApplicationForm from "../Pages/Career/applicationForm";
import ShowApplications from "../Pages/Career/showApplications";
import ViewApplication from "../Pages/Career/viewApplication";
import AgriSubsidy from "../Pages Without Login/agri_subsidy";
import ShowAgriSubsidy from "../Pages Without Login/AgriSubsidy/showagriSubsidy";
// import ViewSubsidy from "../Pages Without Login/SI-Feedback/view_si_feedback";
import ViewSubsidyNew from "../Pages Without Login/AgriSubsidy/viewSubsidy";
// import QuotationPreviewV2 from "../Pages/Quatation/CustomQuatation/view_quotation_v2";
import NaturallyVentilatedPolyhouse from "../Pages Without Login/controllEnvironmentPolyhouse/nvph";
import NetHouse from "../Pages Without Login/controllEnvironmentPolyhouse/netHouse";
import Fanpad from "../Pages Without Login/controllEnvironmentPolyhouse/fanpad";
import FlatBed from "../Pages Without Login/controllEnvironmentPolyhouse/flatBed";
import GrowBags from "../Pages Without Login/controllEnvironmentPolyhouse/growBags";
import DutchBucket from "../Pages Without Login/controllEnvironmentPolyhouse/dutchBucket";
import WhyKryzenBiotech from "../Pages Without Login/controllEnvironmentPolyhouse/whyKryzenBiotech";
import SoftwareServices from "../Pages Without Login/controllEnvironmentPolyhouse/softwareServices";
import AgronomySupportPublic from "../Pages Without Login/controllEnvironmentPolyhouse/agronomySupport";
import EmployeeProgram from "../Pages Without Login/controllEnvironmentPolyhouse/employeeTranning";
import AFrame from "../Pages Without Login/controllEnvironmentPolyhouse/aFrame";
import GrowSlab from "../Pages Without Login/controllEnvironmentPolyhouse/growSlab";
import QuotationnEx from "../Pages Without Login/controllEnvironmentPolyhouse/quotationnEx";
import WebinarHomeRedirect from "../Pages/webinar/webinar_home_redirect";
// import ExpenseTrackingDashboard from "../Pages/Internal/Financial Dashboard/financial_dashboard";
import FinancialDashboard from "../Pages/Internal/Financial Dashboard/financial_dashboard";
import AddFinancialExpense from "../Pages/Internal/Financial Dashboard/addFinancialExpense";
import ViewExpenditure from "../Pages/Internal/Financial Dashboard/view_expenditure";
import FarmingConferencePayment from "../Pages/Farming Conference/farmingConferencePayment";
import ViewFarmingConference from "../Pages/Farming Conference/viewFarmingConference";
import CompanyAssets from "../Pages/Internal/company_assets";
import AddCompanyAssets from "../Pages/Internal/Company Assets/add_company_assets";
import EditCompanyAssets from "../Pages/Internal/Company Assets/edit_company_assets";
import ViewCompanyAssets from "../Pages/Internal/Company Assets/view_company_assets";
import AddStructureUtilization from "../Pages/Client Management/Structure Utilization/add_structure_utilization";
import EditStructureUtilization from "../Pages/Client Management/Structure Utilization/edit_structure_utilization";
import ViewStructureUtilization from "../Pages/Client Management/Structure Utilization/view_structure_utilization";
import StructureUtilization from "../Pages/Client Management/structure_utilization";
import CelebrationPopup from "../Pages/Dashbourd/Kryzen Dashboard Components/celebrationPopup";
import Addcelebratiion from "../Pages/Dashbourd/Kryzen Dashboard Components/celebrationForm";
import ReqForPayment from "../Pages/Purchase/Request For Payment/req_for_payment";
import NHMSubsidy from "../Pages/SubsidySeoPages/nhmSubsidy";
import EditReqForPayment from "../Pages/Purchase/Request For Payment/edit_req_for_payment";
import ReqForPaymentMain from "../Pages/Purchase/req_for_payment";
import ViewReqForPayment from "../Pages/Purchase/Request For Payment/view_req_for_payment";
import Refundpolicy from "../Pages Without Login/controllEnvironmentPolyhouse/refundpolicy";
import PrivacyPolicyNew from "../Pages Without Login/controllEnvironmentPolyhouse/privacy_policy";
import TermsAndConditionsPolicy from "../Pages Without Login/controllEnvironmentPolyhouse/terms_condition";
import NHBSubsidy from "../Pages/SubsidySeoPages/nhbSubsidy";
import AIFSubsidy from "../Pages/SubsidySeoPages/aifSubsidy";
import HydroponicFarmConstruction from "../Pages/SubsidySeoPages/hydrophonicfarmContruction";
import PolyhouseConstruction from "../Pages/SubsidySeoPages/polyhouseConstuction";
import AllShopifyOrders from "../Pages/shopify/shopifyOrders";
import WebinarTickets from "../Pages/webinar/webinarTickets";
import ViewWebinarTickets from "../Pages/webinar/webinars/view_webinar_ticket";
import AgriPurchase from "../Pages Without Login/agripurchase_home";
import CeaNvphHome from "../Pages/Purchase/Cea Nvph Price/ceaNvphHome";
import ConstructDesigns from "../Pages/construction sketch/construct_designs";
import MyOperatorData from "../Pages/Sales/myOp";
import ViewMyOpData from "../Pages/Sales/myOp Leads/myOpDataView";
import SiteinspectionInfo from "../Pages/Client Management/Site Inspection Info/site_inspection_info";
import ShopifyProducts from "../Pages/Purchase/Shopify Inventory/all_products";
import ShopifyProductView from "../Pages/Purchase/Shopify Inventory/view_product_details";
import ShopifyProductEdit from "../Pages/Purchase/Shopify Inventory/edit_product_page";
import ShopifyProductAdd from "../Pages/Purchase/Shopify Inventory/add_product";
import Polyhouseseopages from "../Pages/Polyhouse ImageSeo Pages/polyhouse_seo_pages";
import WebinarFallbackPage from "../Pages Without Login/webinar_fallback";
import GetTestDetails from "../evaluation/evaluation";
import InternalTest from "../evaluation/internal_test";
import NHMApplicants from "../Pages/Sales/NHM Applicants/nhm_applicants";
import ViewNhmApplicants from "../Pages/Sales/NHM Applicants/nhm_applicannts_view";
import ViewEligibleFarmer from "../Pages/Sales/NHM Applicants/nhm_applicants_publicPage";
import ThankYouPage from "../Pages/Sales/NHM Applicants/thankyouPage";
import EditApplicants from "../Pages/Sales/NHM Applicants/nhm_applicannts_edit";
import HydroponicMaterialPlanningNew from "../Pages/Internal/hydroponic_material_planning_new";
import HydroponicMaterialTableNew from "../Pages/Internal/Hydroponic Material Planning/hydroponic_material_table_new";
import ViewMaterialList from "../Pages/Internal/Hydroponic Material Planning/view_material_planning_list";
import GetAllMaterialLists from "../Pages/Internal/Hydroponic Material Planning/getAllLists";
import HydroponicMaterialPlanningNewEdit from "../Pages/Internal/Hydroponic Material Planning/edit_material_planning";
import ConductScrum from "../Pages/Internal/Scrum System/conduct_scrum";
import EditScrum from "../Pages/Internal/Scrum System/edit_conduct_scrum";
import ScrumMeetings from "../Pages/Internal/Scrum System/all_scrum_meetings";
import ViewScrumMeeting from "../Pages/Internal/Scrum System/view_scrum_meeting";
import CreateDriveFolder from "../Pages/Internal/Farm Tranning New/create_folder";
import GetFarmTranningFolders from "../Pages/Internal/Farm Tranning New/all_folder_details";
import ViewDriveDetails from "../Pages/Internal/Farm Tranning New/view_drive_details";
import UploadForm from "../Pages/Internal/Farm Tranning New/upload_folder";
import MaterialTableListComFlatGrow from "../Pages/Internal/Hydroponic Material Planning/materilListComofFlatGrow";
import AddFarmTrainingMedia from "../Pages/FarmTraining Media/add_farmTraining_media";
import ViewFarmTrainingMediaFolders from "../Pages/FarmTraining Media/view_farmTraining_media_folder";
import ViewPerFolderFarmMedia from "../Pages/FarmTraining Media/view_per_folder_farmMedia";
import UpdateFarmTrainingMedia from "../Pages/FarmTraining Media/view_per_folder_farmMedia";
import EmployeeTestOverview from "../evaluation/employee_test_overview";
import AssignTrainingTests from "../evaluation/Trainee Tests/assigned_training_test";
import TraineeTest from "../evaluation/Trainee Tests/trainee_test";
import ViewTraineeTests from "../evaluation/Trainee Tests/view_trainee_tests";
import AllEEP from "../Pages/Internal/Employee Eficiency Program/eep_all_view";
import ViewPerEmployeeEep from "../Pages/Internal/Employee Eficiency Program/view_per_user_eep_data";
import AllKitTracking from "../Pages/Sales/all_kitTracking";
import ViewPerKitTracking from "../Pages/Sales/Kit Tracking/view_kit_tracking";
import EditKitTracking from "../Pages/Sales/Kit Tracking/edit_kit_tracking";
import AddKitTracking from "../Pages/Sales/Kit Tracking/add_kit_tracking";
import OrderCustomerToFarmer from "../Pages/Farm Management/order_customer_to_farmer";
import WebinarInterest from "../Pages/webinar/webinar_interest";
import ViewWebinarInterest from "../Pages/webinar/webinar interest/view_webinar_interest";
import AddSocietyOnboarding from "../Pages/Farm Management/Society Onboarding/add_society_onboard";
import AllSocietyOnbordings from "../Pages/Farm Management/societyOnboarding";
import ViewSocietyOnboarding from "../Pages/Farm Management/Society Onboarding/view_society_onboard";
import EditSocietyOnboarding from "../Pages/Farm Management/Society Onboarding/edit_society_onboard";
import CuOrders from "../Pages/Farm Management/EPG/Orders/customer_orders";
import CuOrderView from "../Pages/Farm Management/EPG/Orders/order_view";
import AddEpgProduct from "../Pages/Epg Products/epg_add_product";
import ProductList from "../Pages/Epg Products/all_epg_product";
import LeadsTrackingSystem from "../Pages/New Leads/leads_tracking_system";
import AddNewLeads from "../Pages/New Leads/add_new_lead";
import EditLeadSys from "../Pages/New Leads/edit_lead";
import LeadsCloserFunnelSystem from "../Pages/New Leads/leads_closer_funnel";
import Addpodcast from "../Pages/Media And Marketing/Podcast/add_podcast";
import Editpodcast from "../Pages/Media And Marketing/Podcast/edit_podcast";
import Podcast from "../Pages/Media And Marketing/Podcast/podcast";
import ViewPodcast from "../Pages/Media And Marketing/Podcast/view_podcast";
import AddReelShorts from "../Pages/Media And Marketing/Reelshorts/add_reelshorts";
import EditReelShort from "../Pages/Media And Marketing/Reelshorts/edit_reelshorts";
// import ReelShortTable from "../Pages/Media And Marketing/Reelshorts/reelshort_table";
import Reelshort from "../Pages/Media And Marketing/Reelshorts/reelshort";
import ViewReelShort from "../Pages/Media And Marketing/Reelshorts/view_reelshorts";
import AddInformativeVideo from "../Pages/Media And Marketing/Informative Video/add_informative_video";
import EditInformativeVideo from "../Pages/Media And Marketing/Informative Video/edit_informative_video";
import InformativeVideos from "../Pages/Media And Marketing/Informative Video/informative_video";
import ViewInformativeVideos from "../Pages/Media And Marketing/Informative Video/view_informative_video";
import AddGraphics from "../Pages/Media And Marketing/Graphics/add_graphics";
import EditGraphics from "../Pages/Media And Marketing/Graphics/edit_graphics";
import Graphics from "../Pages/Media And Marketing/Graphics/all_graphics";
import ViewGraphics from "../Pages/Media And Marketing/Graphics/view_graphics";
import AddGuestDetails from "../Pages/Media And Marketing/Guest Management/add_guest_details";
import EditGuestDetails from "../Pages/Media And Marketing/Guest Management/edit_guest_details";
import Guest from "../Pages/Media And Marketing/Guest Management/guest_details";
import ViewGuestDetails from "../Pages/Media And Marketing/Guest Management/view_guest_details";
import MarketingPipelineSystem from "../Pages/Media And Marketing/Content Pipeline System/content_pipeline_dashboard";
import CreativeStandard from "../Pages/Media And Marketing/Creative Standards/creative_standards";
import AddConceptIdeas from "../Pages/Media And Marketing/Concept & Ideas/add_concept_ideas";
import EditConceptIdeas from "../Pages/Media And Marketing/Concept & Ideas/edit_concept_ideas";
import ConceptIdeas from "../Pages/Media And Marketing/Concept & Ideas/concept_ideas";
import ViewConceptIdeas from "../Pages/Media And Marketing/Concept & Ideas/view_concept_ideas";
import AddCourcedetails from "../Pages/Media And Marketing/Cource/add_topic_details";
import EditCourcedetails from "../Pages/Media And Marketing/Cource/edit_topic_details";
import CourceDetails from "../Pages/Media And Marketing/Cource/topic_details";
import ViewCourceDetails from "../Pages/Media And Marketing/Cource/view_topic_details";
import CourceNameDetails from "../Pages/Media And Marketing/Cource/get_all_cource_name";
import ViewCourceNameDetails from "../Pages/Media And Marketing/Cource/view_course_names";
import EditCourceNamedetails from "../Pages/Media And Marketing/Cource/edit_course_name";
import CreateEnquiryForm from "../Pages/Sales/create_enuiry_form";
import Posting_schedules from "../Pages/Media And Marketing/Posting & Planning/posting_schedules";
import FarmerPartner from "../Pages/Farm Management/farmer_partner";
import OnboardFarmerPartner from "../Pages/Farm Management/Farmer Partners/onboard_farmer_partner";
import FarmerPartnerView from "../Pages/Farm Management/Farmer Partners/view_farmer_partner";
import EditFarmerPartner from "../Pages/Farm Management/Farmer Partners/edit_farmer_partner";
import EpgDashboard from "../Pages/Farm Management/Farmer Partners/epg_dashboard";
import FarmerEpgDashboard from "../Pages/Farm Management/Farmer Partners/farmer_epg_dashboard";
import EpgUserOrderDetails from "../Pages/Farm Management/Farmer Partners/epg_user_order_details";
import ProductView from "../Pages/Epg Products/view_epg_product";
import EditEpgProduct from "../Pages/Epg Products/epg_edit_product";
import CreateVendorBuyOrderForm from "../Pages/Buyers/create_vendor_buy_order";
import PdfAutoDownload from "../Pages Without Login/aif_download_doc";
// import EnquiryTable from "../Pages/Enquiry/enquiry_table";
import NewEnquiryData from "../Pages/Enquiry/enquiryNew";
import LeadMasters from "../Pages/Leads Master/all_lead_masters";
import ViewLeadMaster from "../Pages/Leads Master/view_lead_master";
import View_analytics from "../Pages/Sales/Sales Analysis/view_analytics";
import WhatsappTemplate from "../Pages/Internal/whatsApp_template";
import CampaignAllStat from "../Pages/Internal/campaign_all_stat";
import CampaignStatView from "../Pages/Internal/WhatsAppTemplate/view_campaign_stat";
import WhatsappTemplateSetting from "../Pages/Internal/whatsApp_template_setting";
import ViewWhatsAppTemplateSettingData from "../Pages/Internal/WhatsAppTemplateSetting/whatsapp_template_setting_view";
import EditWhatsAppTemplateDetails from "../Pages/Internal/WhatsAppTemplateSetting/whatsapp_template_setting_edit";
import CreateWhatsAppTemplateDetails from "../Pages/Internal/WhatsAppTemplateSetting/whatsapp_template_setting_create";
import AddSchedule from "../Pages/Media And Marketing/Posting & Planning/add_schedules";
import GetAiCallLogs from "../Pages/AiCall Logs/getaicallLogs";
import CallViewPage from "../Pages/AiCall Logs/viewaicalldetails";
// import c from "../Pages/Ai Bookings/aibookingTable";
import GetAiBookings from "../Pages/Ai Bookings/getAiBookings";
import ViewBookingDetails from "../Pages/Ai Bookings/viewaiBookingDetails";
import SalaryLogin from "../Pages/Internal/Employee Salary/salary_verification";
import QuotationPreviewV2 from "../Pages/Quatation/CustomQuatation/view_quotation_v2";
import AddCandidateDetails from "../Pages/Internal/Interview Pipeline/add_candidate_details";
import EditCandidateDetails from "../Pages/Internal/Interview Pipeline/edit_cadidate_details";
import ViewCandidateDetails from "../Pages/Internal/Interview Pipeline/view_candidate_details";
import InterviewCandidates from "../Pages/Internal/Interview Pipeline/interview_candidates";
import InterviewPipelineSystem from "../Pages/Internal/Interview Pipeline/interview_pipeline_dashboard";
import OnboardDeliveryPartner from "../Pages/Farm Management/Farmer Partners/onboard_delivery_partner";
import DeliveryTracking from "../Pages/Farm Management/Farmer Partners/delivery_partner_map";
import DeliveryPartnerDashboard from "../Pages/Farm Management/delivery_partner_dashboard";
import ViewOrderAssigns from "../Pages/Farm Management/Farmer Partners/view_order_assign";
import PreviewPaymentReceipt from "../Pages/Sales/Incentive/payment_receipt";
import LeadTransfer from "../Pages/New Leads/lead_transfer";
import GetTransferLeads from "../Pages/New Leads/get_transfer_leads";
import ViewTransferDetails from "../Pages/New Leads/view_transfer_lead";
import AddEpgRecipe from "../Pages/EPG Recipe/add_epg_recipe";
import EditEpgRecipe from "../Pages/EPG Recipe/edit_epg_recipe";
import AllEpgRecipe from "../Pages/EPG Recipe/all_epg_recipe";
import RecipeView from "../Pages/EPG Recipe/view_epg_recipe";
import ViewPostSchedule from "../Pages/Media And Marketing/Posting & Planning/view_schedules";
import SalesDailyReport from "../Pages/Dashbourd/salesDailyReport";
import AddServiceOrder from "../Pages/Purchase/Service Order/add_service_order";
import ServiceOrder from "../Pages/Purchase/service_order";
import EditServiceOrder from "../Pages/Purchase/Service Order/edit_service_order";
import ViewServiceOrder from "../Pages/Purchase/Service Order/view_service_order";
import PreviewServiceOrder from "../Pages/Purchase/Service Order/preview_service_order";
import AddGRNPurchaseOrder from "../Pages/Purchase/GRN System/add_grn_system";
import EditGRNPurchaseOrder from "../Pages/Purchase/GRN System/edit_grn_system";
import GrnSystem from "../Pages/Purchase/GRN System/grn_system";
import ViewGrn from "../Pages/Purchase/GRN System/view_grn_system";
import GrnPreview from "../Pages/Purchase/GRN System/grn_priview_pdf";
import WeeklyTemplate from "../Pages/Editing Tamplate/crouselUImage";
import PodcastCard from "../Pages/Editing Tamplate/templateEditor";
import PodcastGuest2Card from "../Pages/Editing Tamplate/podcastGuest2";
import QuoteCard from "../Pages/Editing Tamplate/QuoteTamplate";
import CrouselNewsCard from "../Pages/Editing Tamplate/crouselUImage";
import ADDRequestForMaterial from "../Pages/Purchase/Request For Material/add_req_for_material";
import EditRequestForMaterial from "../Pages/Purchase/Request For Material/edit_req_for_material";
import RFM from "../Pages/Purchase/Request For Material/req_for_material";
import ViewRFM from "../Pages/Purchase/Request For Material/view_req_for_material";
import CreateMarketingDeliveryTask from "../Pages/Media And Marketing/Media Delivery/media_delivery_assign_task";
import EditMarketingDeliveryTask from "../Pages/Media And Marketing/Media Delivery/edit_media_delivery_task";
import MediaDelivery from "../Pages/Media And Marketing/Media Delivery/media_delivery_task";
import ViewTaskDetails from "../Pages/Media And Marketing/Media Delivery/view_media_delivery_task";
import AlphaCallTracking from "../Pages/Sales/alpha_call_tracking";
import PoExtraPayment from "../Pages/Purchase/PoGrnExtraPayment/pogrnextraPayment";
import ViewPoGrnPaymentDetails from "../Pages/Purchase/PoGrnExtraPayment/view_poGrnPaymentDetails";

const routes = [
  {
    path: "/i-dashboard",
    roles: [
      process.env.REACT_APP_ROLE_INTERNAL,
      process.env.REACT_APP_ROLE_ADMIN_S,
    ],
    ele: <KryzenDashBoard />,
  },
  {
    path: "/sales-dashboard",
    roles: [
      process.env.REACT_APP_ROLE_INTERNAL,
      process.env.REACT_APP_ROLE_ADMIN_S,
    ],
    ele: <SalesDailyReport />,
  },
  {
    path: "/employee-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <EmployeeManagement />,
  },
  {
    path: "/employee-management/oldEmployee",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <EmployeeManagementLeftEmployee />,
  },

  {
    path: "/employee-leave-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <EmployeeLeaveManagement />,
  },
  {
    path: "/employee-documents",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EmployeeDocuments />,
  },
  {
    path: "/employee-attendance",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
    ],
    ele: <EmployeeAttendance />,
  },
  {
    path: "/employee-attendance/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
    ],
    ele: <ViewAttendance />,
  },
  {
    path: "/internal-FAQ",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <InternalFAQ />,
  },
  {
    path: "/standard-quotation",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <StandardQuotation />,
  },
  {
    path: "/standard-quotation/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <ViewQuotationMatrix />,
  },
  {
    path: "/custom-quotation",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <CustomQuotation />,
  },
  {
    path: "/client-demo-planning",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ClientDemoPlanning />,
  },
  {
    path: "/leads",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESAGENCY,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <AllLeads />,
  },
  {
    path: "/my-operator",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <MyOperatorData />,
  },
  {
    path: "/my-operator/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewMyOpData />,
  },
  {
    path: "/call-records",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <CallRecords />,
  },
  {
    path: "/enquiry",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <Enquiry />,
  },
  {
    path: "/revenue-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <IncentiveManagement />,
  },
  {
    path: "/reimbursement-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ReimbursementManagement />,
  },
  {
    path: "/reimbursement-management.csv",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ReimbursementManagement />,
  },
  {
    path: "/reimbursement-management/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <AddReimbursement />,
  },
  {
    path: "/reimbursement-management/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <EditReimbursement />,
  },
  {
    path: "/revenue-management/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <AddIncentive />,
  },
  {
    path: "/revenue-management/payment-receipt/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <PreviewPaymentReceipt />,
  },
  {
    path: "/revenue-management/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditIncentive />,
  },
  {
    path: "/client-site-inspection",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,

      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ClientSiteInspection />,
  },

  {
    path: "/client-project-handover",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <ClientProjectHandover />,
  },
  {
    path: "/client-project-tracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ClientProjectTracking />,
  },
  {
    path: "/client-subsidy-documents-upload",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <SubsidyDocuments />,
  },
  {
    path: "/client-subsidy-documents/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewSubsidyDocuments />,
  },
  {
    path: "/client-projects",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESCOORDINATOR
    ],
    ele: <ClientProject />,
  },
  {
    path: "/client-payment-tracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ClientPaymentTracking />,
  },
  {
    path: "/client-expense-tracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ClientExpenceTracking />,
  },

  {
    path: "/farm-nursery-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <FarmNurseryManagement />,
  },
  {
    path: "/farm-nursery-management/new-batch",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddBatch />,
  },
  {
    path: "/farm-nursery-management/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewBatch />,
  },
  {
    path: "/farm-nursery-management/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditBatch />,
  },
  {
    path: "/farm-water-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <FarmWaterManagement />,
  },
  {
    path: "/farm-water-management/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <CreateWaterCycle />,
  },
  {
    path: "/farm-water-management/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditWaterCycle />,
  },
  {
    path: "/farm-water-management/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewWaterManagement />,
  },
  {
    path: "/nutrient-calculations",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <NutrientCalculations />,
  },
  {
    path: "/farm-construction",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,

      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <FarmConstructionAgreement />,
  },

  {
    path: "/farm-construction/quotation",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <Quotation />,
  },
  {
    path: "/farm-construction/agreement",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,

      process.env.REACT_APP_ROLE_AGRONOMIST,

      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <FarmAgreement />,
  },
  {
    path: "/farm-operations-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <FarmOperationsManagement />,
  },

  // {
  //   path: "/buyers-produce-demand",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,

  //     process.env.REACT_APP_ROLE_MARKETING,

  //     process.env.REACT_APP_ROLE_CLIENT,
  //
  //   ],
  //   ele: <BuyersProduceDemand />,
  // },
  {
    path: "/buyers-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
    ],
    ele: <BuyersManagement />,
  },

  {
    path: "/buyers-ltc",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <Longtermcontract />,
  },

  {
    path: "/buyers-management/new",
    roles: [
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_MARKETING,
    ],
    ele: <AddBuyer />,
  },
  {
    path: "/buyers-management/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_MARKETING,
    ],
    ele: <EditBuyer />,
  },

  {
    path: "/buyers-management/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewBuyer />,
  },
  {
    path: "/buyers-price-watcher",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_MARKETING,
    ],
    ele: <BuyersPriceWatcher />,
  },
  {
    path: "/buyers-price-watcher/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_MARKETING,
    ],
    ele: <AddPriceWatcher />,
  },
  {
    path: "/buyers-price-watcher/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewPriceWatcher />,
  },
  {
    path: "/buyers-price-watcher/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_MARKETING,
    ],
    ele: <EditPriceWatcher />,
  },
  {
    path: "/client-employee-database",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <ClientEmployeeDatabase />,
  },
  {
    path: "/client-employee-database/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <AddWorkforce />,
  },
  {
    path: "/client-employee-database/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <EditWorkforce />,
  },
  {
    path: "/client-employee-database/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <ViewWorkforce />,
  },

  {
    path: "/purchase-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <PurchaseOrder />,
  },
  {
    path: "/delivery-challan",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <DeliveryChallan />,
  },
  {
    path: "/purchase-vendor-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <PurchaseVendorManagement />,
  },
  {
    path: "/purchase-contract-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <PurchaseContractManagement />,
  },
  {
    path: "/project-specification",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <PurchaseProjectSpecification />,
  },
  {
    path: "/project-specification/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <AddProjectSpecification />,
  },
  {
    path: "/project-specification/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <EditProjectSpecification />,
  },
  {
    path: "/project-specification/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <ViewProjectSpecification />,
  },
  {
    path: "/project-specification/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <PreviewSpecification />,
  },
  {
    path: "/agronomy-plants-wiki",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AgronomyPlantsWiki />,
  },
  {
    path: "/agronomy-plants-wiki/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AddAgronomyWiki />,
  },
  {
    path: "/agronomy-plants-wiki/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewAgronomyWiki />,
  },
  {
    path: "/agronomy-plants-wiki/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditAgronomyWiki />,
  },
  {
    path: "/agronomy-farm-support",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AgronomyClientManagement />,
  },
  {
    path: "/agronomy-farm-support/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddFarmQuery />,
  },
  {
    path: "/agronomy-farm-support/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewQuery />,
  },
  {
    path: "/resources-assets",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ResourcesAssets />,
  },
  {
    path: "/resources-assets/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddAssets />,
  },
  {
    path: "/resources-assets/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditAssets />,
  },
  {
    path: "/resources-assets/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewAssets />,
  },

  {
    path: "/resources-inventory",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ResourcesInventory />,
  },
  {
    path: "/resources-inventory/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditInventory />,
  },
  {
    path: "/resources-inventory/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddInventory />,
  },
  {
    path: "/resources-inventory/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewInventory />,
  },

  {
    path: "/employee-management/new-employee",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <AddEmployee />,
  },
  {
    path: "/employee-management/view-employee/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <ViewEmployee />,
  },
  {
    path: "/employee-management/edit-employee/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <EditEmployee />,
  },

  {
    path: "/employee-leave-management/new-leave",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <AddEmployeeLeves />,
  },
  {
    path: "/employee-leave-management/edit/:id/:index",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <EditLeaves />,
  },
  {
    path: "/employee-leave-management/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <ViewLeaves />,
  },

  {
    path: "/attendance",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <Attendance />,
  },
  {
    path: "/logout-attendance",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <AttendanceLogout />,
  },
  {
    path: "/custom-quotation/new-quotation",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <AddQuotation />,
  },
  {
    path: "/custom-quotation/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <QuotationPreview />,
  },
  {
    path: "/custom-quotation-v2/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <QuotationPreviewV2 />,
  },
  // {
  //   path: "/custom-quotation-v2/:id",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_PURCHASE,
  //     process.env.REACT_APP_ROLE_SALLE,
  //     process.env.REACT_APP_ROLE_SALLE_ADMIN,
  //     process.env.REACT_APP_ROLE_SALES_MANAGER,
  //     process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
  //   ],
  //   ele: <QuotationPreviewV2 />,
  // },

  {
    path: "/custom-quotation/edit-quotation/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditQuotation />,
  },
  {
    path: "/standard-quotation/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <EditQuotationMatrix />,
  },
  {
    path: "/leads/new-lead",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESAGENCY,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <AddLeads />,
  },
  {
    path: "/leads/view-lead/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESAGENCY,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewLeads />,
  },
  {
    path: "/leads/edit-lead/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESAGENCY,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditLeads />,
  },
  {
    path: "/purchase-vendor-management/new-vendor",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddVendor />,
  },
  {
    path: "/purchase-vendor-management/edit-vendor/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditVendor />,
  },
  {
    path: "/purchase-vendor-management/view-vendor/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewVendor />,
  },

  {
    path: "/purchase-order/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddPurchaseOrder />,
  },
  {
    path: "/purchase-order/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditPurchaseOrder />,
  },
  {
    path: "/purchase-order/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewPurchaseOrder />,
  },
  {
    path: "/purchase-order/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <PreviewPurchaseOrder />,
  },

  //
  // {
  //   path: "/purchase-vendor-management/new-vendor",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_PURCHASE,
  //     process.env.REACT_APP_ROLE_ACCOUNTS,
  //   ],
  //   ele: <AddVendor />,
  // },
  // {
  //   path: "/service-vendor-management/edit-vendor/:id",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_PURCHASE,
  //     process.env.REACT_APP_ROLE_ACCOUNTS,
  //   ],
  //   ele: <EditVendor />,
  // },
  // {
  //   path: "/service-vendor-management/view-vendor/:id",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_PURCHASE,
  //     process.env.REACT_APP_ROLE_ACCOUNTS,
  //   ],
  //   ele: <ViewVendor />,
  // },

  {
    path: "/service-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ServiceOrder />,
  },

  {
    path: "/service-order/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddServiceOrder />,
  },
  {
    path: "/service-order/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditServiceOrder />,
  },
  {
    path: "/service-order/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewServiceOrder />,
  },
  {
    path: "/service-order/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <PreviewServiceOrder />,
  },

  //

  {
    path: "delivery-challan/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddDeliveyChallan />,
  },
  {
    path: "delivery-challan/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewDeliveryChallan />,
  },
  {
    path: "delivery-challan/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditDeliveyChallan />,
  },
  {
    path: "delivery-challan/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <PreviewDeliveryChallan />,
  },

  {
    path: "/client-projects/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESCOORDINATOR
    ],
    ele: <AddClientProject />,
  },
  {
    path: "/client-projects/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESCOORDINATOR
    ],
    ele: <ViewClientProject />,
  },
  {
    path: "/client-projects/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESCOORDINATOR
    ],
    ele: <EditClientProject />,
  },

  {
    path: "/client-site-inspection/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],

    ele: <AddSiteInspection />,
  },
  {
    path: "/client-site-inspection/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditClientSiteInspection />,
  },
  {
    path: "/client-site-inspection/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewSiteInspection />,
  },
  {
    path: "/client-site-inspection/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,

      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <SiteInspectionPreview />,
  },

  {
    path: "/client-site-inspection-aif/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,

      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <SiteInspectionPreviewAIF />,
  },

  {
    path: "/client-project-tracking/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <AddProjectTracking />,
  },
  {
    path: "/client-project-tracking/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <EditProjectTracking />,
  },
  {
    path: "/client-project-tracking/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,

      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ViewProjectTracking />,
  },

  {
    path: "/client-expense-tracking/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddExpense />,
  },
  {
    path: "/client-expense-tracking/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewExpenseTracking />,
  },
  {
    path: "/client-expense-tracking/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditExpenseTracking />,
  },
  {
    path: "/client-payment-tracking/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddPaymentTracking />,
  },
  {
    path: "/client-payment-tracking/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewPaymentTracking />,
  },
  {
    path: "/client-payment-tracking/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditPaymentTracking />,
  },
  {
    path: "/client-project-handover/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditProjectHandover />,
  },
  {
    path: "/client-project-handover/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddProjectHandover />,
  },
  {
    path: "/client-project-handover/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewHandover />,
  },
  {
    path: "/client-feedback",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ClientFeedback />,
  },
  {
    path: "/leads-tracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,

      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <LeadsTracking />,
  },
  {
    path: "/leads-filtered",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,

      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <LeadsFiltered />,
  },
  {
    path: "/leads-filtered/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,

      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewLeads />,
  },
  {
    path: "/leads-filtered/Edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,

      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditLeads />,
  },
  {
    path: "/leads-followup",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,

      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <LeadsFollowup />,
  },
  {
    path: "/call-tracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <CallTracking />,
  },
  {
    path: "/construction-designer",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <ConstructDesigns />,
  },
  {
    path: "/leads-followup/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,

      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewLeads />,
  },
  {
    path: "/leads-followup/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,

      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditLeads />,
  },
  {
    path: "/client-feedback/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <AddClientFeedback />,
  },
  {
    path: "/si-feedback-recieved",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_OPS,
    ],
    ele: <SiteInspectionAll />,
  },
  {
    path: "/si-feedback-recieved/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_OPS,
    ],
    ele: <ViewSiteInsppectionFeedback />,
  },
  {
    path: "/client-invoice",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <ClientInvoice />,
  },
  {
    path: "/client-invoice/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <AddClientInvoice />,
  },
  {
    path: "/client-invoice/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <ViewClientInvoice />,
  },
  {
    path: "/client-invoice/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <EditClientInvoice />,
  },
  {
    path: "/client-invoice/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <PreviewClientInvoice />,
  },
  {
    path: "/cold-leads",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESAGENCY,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ColdLeadsTracking />,
  },
  {
    path: "/farm-training/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <AddFarmTraining />,
  },
  {
    path: "/farm-training/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditFarmTraining />,
  },
  {
    path: "/farm-training/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewFarmTraining />,
  },
  {
    path: "/farm-training",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <FarmTraining />,
  },
  {
    path: "/marketing",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <MarketingSystem />,
  },
  {
    path: "/marketing/view-client/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewMarketingClient />,
  },
  {
    path: "/campaign/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CreateCampaign />,
  },
  {
    path: "/campaign/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CreateCampaign />,
  },
  {
    path: "/task-management/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <CreateTask />,
  },
  {
    path: "/task-management/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <EditTask />,
  },
  {
    path: "/task-management/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ViewTasks />,
  },
  {
    path: "/task-management/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <TaskManagement />,
  },
  {
    path: "/buyers-price-watcher/research",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ResearchRnn />,
  },
  {
    path: "/android-app",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <MobileApp />,
  },
  {
    path: "/android-app/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewMobileApp />,
  },
  {
    path: "/watsapp-logs",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <WatsappLog />,
  },
  {
    path: "/watsapp-logs/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewWatsappLog />,
  },
  {
    path: "/site-inspection/new",
    roles: [
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CreateSiteInspection />,
  },
  {
    path: "/site-inspection",
    roles: [
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ClientSiteInspectionRole />,
  },
  {
    path: "/site-inspection/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewSI />,
  },
  {
    path: "/site-inspection/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <PreviewSI />,
  },
  {
    path: "/site-inspection/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_SITE_INSPECTION,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditSI />,
  },
  {
    path: "/sales-analytics",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <SalesDashboard />,
  },
  {
    path: "/sales-analytics/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <View_analytics />,
  },
  {
    path: "/sales-updates",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <SalesUpdates />,
  },
  {
    path: "/farm-harvest-management",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <FarmHarvestManagement />,
  },

  {
    path: "/farm-harvest-management/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <HarvestCreate />,
  },

  {
    path: "/farm-harvest-management/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <HarvestView />,
  },
  {
    path: "/farm-harvest-management/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <HarvestEdit />,
  },
  {
    path: "/farm-crop-schedule",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <CropUpdate />,
  },
  {
    path: "/labour-training",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <FarmLabourTrainning />,
  },
  {
    path: "/labour-training/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddLabourTrainning />,
  },
  {
    path: "/labour-training/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditLabourTraningSchedule />,
  },
  {
    path: "/labour-training/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewSchedule />,
  },
  // {
  //   path: "/labour-training/edit/:id",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_AGRONOMIST,
  //     process.env.REACT_APP_ROLE_CLIENT,
  //     process.env.REACT_APP_ROLE_OPS,
  //     process.env.REACT_APP_ROLE_SALES_MANAGER,
  //   ],
  //   ele: <EditLabourTraningSchedule />,
  // },
  {
    path: "/farm-crop-schedule/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <CreateCropUpdate />,
  },
  {
    path: "/farm-crop-schedule/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditCropUpdate />,
  },
  {
    path: "/farm-crop-schedule/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewCropUpdate />,
  },
  {
    path: "/agronomy-pest-disease",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <PestDisease />,
  },
  {
    path: "/agronomy-pest-disease/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddPestDisease />,
  },
  {
    path: "/agronomy-pest-disease/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewPestDisease />,
  },
  {
    path: "/agronomy-pest-disease/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditPestDisease />,
  },
  {
    path: "/hydrobuild-onboard",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <OnboardhydroBuild />,
  },

  {
    path: "/hydrobuild",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <OnboardhydroBuildMain />,
  },
  {
    path: "/hydrobuild-logs/:uid",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <HydrobuildLogs />,
  },
  // {
  //   path: "/hydrobuild-onboard",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_AGRONOMIST,
  //     process.env.REACT_APP_ROLE_OPS,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_SALES_MANAGER,
  //     process.env.REACT_APP_ROLE_CLIENT,
  //   ],
  //   ele: <OnboardhydroBuild />,
  // },
  // {
  //   path: "/hydrobuild",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_AGRONOMIST,
  //     process.env.REACT_APP_ROLE_OPS,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_SALES_MANAGER,
  //     process.env.REACT_APP_ROLE_CLIENT,
  //   ],
  //   ele: <OnboardhydroBuildMain />,
  // },
  // {
  //   path: "/hydrobuild-logs/:uid",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //     process.env.REACT_APP_ROLE_AGRONOMIST,
  //     process.env.REACT_APP_ROLE_OPS,
  //     process.env.REACT_APP_ROLE_ADMIN,
  //     process.env.REACT_APP_ROLE_SALES_MANAGER,
  //     process.env.REACT_APP_ROLE_CLIENT,
  //   ],
  //   ele: <HydrobuildLogs />,
  // },
  {
    path: "/employee-salary",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <EmployeeSalary />,
  },
  {
    path: "/employee-payslip",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <PreviewPayslips />,
  },
  {
    path: "/material-planning",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <MaterialPlanning />,
  },
  {
    path: "/material-planning/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <ViewMaterial />,
  },
  {
    path: "/material-planning/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <EditMaterial />,
  },
  {
    path: "/hydroponic-material-planning",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <HydroponicMaterialPlanning />,
  },
  {
    path: "/hydroponic-material-inventory",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <HydroponicInventory />,
  },
  {
    path: "/hydroponic-material-inventory/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ADMIN,
    ],

    ele: <AddHMInvetory />,
  },
  {
    path: "/hydroponic-material-inventory/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditHMInentory />,
  },
  {
    path: "/hydroponic-material-planning/table",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <HydroponicMaterialTable />,
  },
  {
    path: "/cea-nvph-pricing",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <CeaNvphHome />,
  },
  {
    path: "/farm-plants-inventory",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <FarmerInventory />,
  },
  {
    path: "/epg-farmer-inventory/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <FarmerInventoryView />,
  },
  {
    path: "/farm-shop",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <FarmerShop />,
  },
  {
    path: "/farm-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <FarmerOrders />,
  },
  {
    path: "/farm-order/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <FarmerOrderView />,
  },
  {
    path: "/farm-cnf-inventory",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CnFInventory />,
  },
  {
    path: "/farm-cnf-plants-inventory/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CnFPlantInventoryView />,
  },
  {
    path: "/farm-cnf-shop",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CnfShop />,
  },
  {
    path: "/farm-cnf-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CnFOrders />,
  },
  {
    path: "/farm-cu-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CuOrders />,
  },
  {
    path: "/orders-tally",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <OrdersTally />,
  },
  {
    path: "/farmer-revenue",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <OrdersRevenue />,
  },
  {
    path: "/farm-cnf-order/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CnfOrderView />,
  },
  {
    path: "/farm-cu-order/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CuOrderView />,
  },
  {
    path: "/farmer-partners",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <FarmerPartner />,
  },
  {
    path: "/farmer-partners/onboard",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <OnboardFarmerPartner />,
  },
  {
    path: "/farmer-partners/onboard-delivery-partner",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <OnboardDeliveryPartner />,
  },
  {
    path: "/delivery-partner/track-order/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_DELIVERY_PARTNER,
    ],
    ele: <DeliveryTracking />,
  },
  {
    path: "/delivery-partner/dashboard/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_DELIVERY_PARTNER,
    ],
    ele: <DeliveryPartnerDashboard />,
  },
  {
    path: "/farmer-partners/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <FarmerPartnerView />,
  },
  {
    path: "/farmer-partners/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditFarmerPartner />,
  },
  {
    path: "/epg-dashboard",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EpgDashboard />,
  },
  {
    path: "/farmer-epg-dashboard",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <FarmerEpgDashboard />,
  },
  {
    path: "/farmer-epg-dashboard/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <FarmerEpgDashboard />,
  },
  {
    path: "/farmer-epg-user-order_details/:orderId/:farmerPartnerAssigned",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <EpgUserOrderDetails />,
  },
  {
    path: "/view-order-assigns/:orderId/:farmerPartnerAssigned",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_DELIVERY_PARTNER,
    ],
    ele: <ViewOrderAssigns />,
  },
  {
    path: "/kryzen-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <KryzenOrders />,
  },

  {
    path: "/kryzen-order/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <KryzenOrderView />,
  },
  {
    path: "/add-address",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_CLIENT,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <Addaddress />,
  },

  {
    path: "/email-matrics",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EmailMatrics />,
  },

  {
    path: "/email-marketing",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <Emailmarketing />,
  },

  {
    path: "/edit-email-template/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <Editemailtemplate />,
  },
  {
    path: "/create-email-template",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <Createemailtemplate />,
  },
  {
    path: "/send-bulk-email/:tempName",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <Sendbulktemplatemails />,
  },
  {
    path: "/employee-feedbacks",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],

    ele: <ViewEmployeeFeedback />,
  },
  {
    path: "/employee-feedbacks",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],

    ele: <AddEmployeeFeedback />,
  },

  {
    path: "/add-employee-feedbacks",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],

    ele: <AddEmployeeFeedback />,
  },

  {
    path: "/employee-feedbacks/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],

    ele: <ShowFeedback />,
  },
  {
    path: "/create-si/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <AddSiUpdates />,
  },

  {
    path: "/si-updates",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <SiUpdates />,
  },
  {
    path: "/company-assets",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <CompanyAssets />,
  },
  {
    path: "/company-assets/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <AddCompanyAssets />,
  },
  {
    path: "/company-assets/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <EditCompanyAssets />,
  },
  {
    path: "/company-assets/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <ViewCompanyAssets />,
  },

  {
    path: "/si-updates/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewSiUpdates />,
  },

  {
    path: "/si-updates/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditSIUpdate />,
  },
  {
    path: "/employee-management/preview-offer-letter/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <OfferLetter />,
  },
  {
    path: "/employee-eficiency-program",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EEP />,
  },

  {
    path: "/refund",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <Refund />,
  },

  {
    path: "/refund/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewRefund />,
  },

  {
    path: "/cricket-match",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <CricketStartPage />,
  },

  {
    path: "/show-teams",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ShowteamPage />,
  },

  {
    path: "/view-match/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ViewcricketMatch />,
  },
  {
    path: "/si-schedules/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewSiSchedules />,
  },
  {
    path: "/si-schedules",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <SiSchedules />,
  },
  {
    path: "/rfq/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewRFQ />,
  },
  {
    path: "/rfq/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ADDRFQ />,
  },
  {
    path: "/rfq/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      // process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditRFQ />,
  },
  {
    path: "/rfq",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <RFQ />,
  },

  {
    path: "/rfq/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <PreviewRFQ />,
  },

  {
    path: `/update-followers/`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddFollowers />,
  },
  {
    path: "/create-si-schedules/new/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <CreateSiSchedules />,
  },
  {
    path: "/edit-si-schedules/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditSiSchedules />,
  },
  {
    path: "/schedule-site-inspection-by-sales",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <SIschedulesBySales />,
  },

  {
    path: "/create-si-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <CreateOrder />,
  },
  {
    path: "/edit-schedule-site-inspection-by-sales/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditSIschedulesBySales />,
  },
  {
    path: "/get-all-employees-salary",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AllEmployeeSalary />,
  },

  {
    path: "/estimate/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddEstimate />,
  },

  {
    path: "/estimate",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <Estimate />,
  },

  {
    path: "/estimate/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewEstimate />,
  },

  {
    path: "/estimate/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditEstimate />,
  },

  {
    path: "/estimate/preview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <PreviewEstimate />,
  },

  {
    path: "/credit-notes",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <CreditNotes />,
  },

  {
    path: "/credit-notes/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewCreditNotes />,
  },
  {
    path: "/feature-docs",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
    ],
    ele: <FeatureDocs />,
  },
  {
    path: "/feature-docs/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
    ],
    ele: <AddFeature />,
  },
  {
    path: "/feature-docs/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
    ],
    ele: <EditFeature />,
  },
  {
    path: "/feature-docs/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
    ],
    ele: <ViewFeature />,
  },

  {
    path: "/complete-projects",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <CompleteProjects />,
  },
  {
    path: "/complete-projects/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ViewComplatedprojects />,
  },
  {
    path: "/create-webinar",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CreateWebinar />,
  },
  {
    path: "/edit-webinar/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditWebinar />,
  },
  {
    path: "/view-webinar-payments",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AllWebinarPayments />,
  },
  {
    path: "/all-webinars",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AllWebinars />,
  },
  {
    path: "/all-webinars-tickets",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <WebinarTickets />,
  },
  {
    path: "/webinar/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewWebinar />,
  },
  {
    path: "/webinar-tickets/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewWebinarTickets />,
  },
  {
    path: "/webinar/view/webinar-feedback",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewWebinarFeedbacks />,
  },
  {
    path: "/webinar/view-webinar-feedbacks/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ShowWebinarFeedback />,
  },
  {
    path: "/get-weekly-revenue",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <Barchart />,
  },

  {
    path: "/get-monthly-revenue",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <MonthlyRevenue />,
  },

  {
    path: "/all-revenue-overview",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <Allgraphs />,
  },

  {
    path: "/all-revenue-paichart",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <WeeklyRevenuePaiChart />,
  },

  {
    path: "/weekly-step-graph",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <StepGraph />,
  },
  {
    path: "/view-webinar-chats",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewWebinarChat />,
  },
  {
    path: "/view-webinar-chats/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ShowWebinarChats />,
  },

  {
    path: "/show-applications",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <ShowApplications />,
  },

  {
    path: "/view-applications/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <ViewApplication />,
  },

  {
    path: "/get-subsidies",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ShowAgriSubsidy />,
  },

  {
    path: "/view-subsidies/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewSubsidyNew />,
  },

  // {
  //   path: "/webinar/view/:id",
  //   roles: [
  //     process.env.REACT_APP_ROLE_ADMIN_S,
  //   ],
  //   ele: <EditWebinar />,
  // },
  {
    path: "/financial-dashboard",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <FinancialDashboard />,
  },
  {
    path: "/add-financial-expense",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AddFinancialExpense />,
  },
  {
    path: "/view-financial-expense",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewExpenditure />,
  },
  {
    path: "/farming-conference",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <FarmingConferencePayment />,
  },
  {
    path: "/view-farming-conference/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewFarmingConference />,
  },

  {
    path: "/structure-utilization/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <StructureUtilization />,
  },

  {
    path: "/create-structure-utilization/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddStructureUtilization />,
  },
  {
    path: "/edit-structure-utilization/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <EditStructureUtilization />,
  },
  {
    path: "/view-structure-utilization/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewStructureUtilization />,
  },
  {
    path: "/celebration/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <Addcelebratiion />,
  },

  {
    path: "/req-for-payment/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ReqForPaymentMain />,
  },

  {
    path: "/req-for-payment/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ReqForPayment />,
  },

  {
    path: "/req-for-payment/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      // process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditReqForPayment />,
  },

  {
    path: "/req-for-payment/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewReqForPayment />,
  },

  {
    path: "/schedule-celebration/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <CelebrationPopup />,
  },

  //  shopify
  {
    path: "/shopify-orders",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AllShopifyOrders />,
  },
  {
    path: "/shopify-innventory/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ShopifyProducts />,
  },
  {
    path: "/shopify-product/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ShopifyProductView />,
  },
  {
    path: "/shopify-product/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ShopifyProductEdit />,
  },
  {
    path: "/add-product/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ShopifyProductAdd />,
  },
  {
    path: "/my-scoreboard/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <GetTestDetails />,
  },
  {
    path: "/internal-test/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <InternalTest />,
  },

  {
    path: "/assign-tests",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <AssignTrainingTests />,
  },
  {
    path: "/trainee-tests/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <TraineeTest />,
  },
  {
    path: "/trainees-overview/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <ViewTraineeTests />,
  },
  {
    path: "/nhm-applicants",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <NHMApplicants />,
  },

  {
    path: "/view-nhm-applicants/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewNhmApplicants />,
  },

  {
    path: "/edit-nhm-applicants/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditApplicants />,
  },

  {
    path: "/new-material-planning-list",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <HydroponicMaterialPlanningNew />,
  },

  {
    path: "/view-material-planning-list/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <ViewMaterialList />,
  },

  {
    path: "/new-material-planning-list/table/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <HydroponicMaterialTableNew />,
  },

  {
    path: "/get-material-lists",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <GetAllMaterialLists />,
  },

  {
    path: "/edit-material-planning-list/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <HydroponicMaterialPlanningNewEdit />,
  },
  {
    path: "/price-scrapper",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
    ],
    ele: <PriceWatcherScrapper />,
  },
  {
    path: "/price-scrapper/view/:alphaPlantId",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
    ],
    ele: <ViewPriceWatcherScrapper />,
  },
  {
    path: "/add-farmTraining-media",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <AddFarmTrainingMedia />,
  },
  {
    path: "/view-farmTraining-media",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
    ],
    ele: <ViewFarmTrainingMediaFolders />,
  },
  {
    path: "/view-perFolder-farmTraining-media/:subfolder",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
    ],
    ele: <ViewPerFolderFarmMedia />,
  },
  {
    path: "/update-perFolder-farmTraining-media/:subfolder",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <UpdateFarmTrainingMedia />,
  },

  {
    path: "/conduct-new-scrum",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <ConductScrum />,
  },

  {
    path: "/conduct-scrum-edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_IT,
    ],
    ele: <EditScrum />,
  },

  {
    path: "/scrum-meetings/",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ScrumMeetings />,
  },
  {
    path: "/view-scrum-meetings/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <ViewScrumMeeting />,
  },

  {
    path: "/create-drive",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <CreateDriveFolder />,
  },

  {
    path: "/get-folders",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <GetFarmTranningFolders />,
  },

  {
    path: "/view-farm-tranig-details/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <ViewDriveDetails />,
  },
  {
    path: "/upload-folder/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
    ],
    ele: <UploadForm />,
  },
  {
    path: "/employee-test-overview/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
    ],
    ele: <EmployeeTestOverview />,
  },

  {
    path: "/material-list-flat-grow/table",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
    ],
    ele: <MaterialTableListComFlatGrow />,
  },
  {
    path: "/EEP",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <AllEEP />,
  },
  {
    path: "/EEP/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_ACCOUNTS,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <ViewPerEmployeeEep />,
  },
  {
    path: "/kitTracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <AllKitTracking />,
  },
  {
    path: "/kitTracking/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <ViewPerKitTracking />,
  },
  {
    path: "/kitTracking/edit/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <EditKitTracking />,
  },
  {
    path: "/addKitTracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <AddKitTracking />,
  },
  {
    path: "/orderCustomerToFarmer",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <OrderCustomerToFarmer />,
  },
  {
    path: "/webinarInterest",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <WebinarInterest />,
  },
  {
    path: "/webinarInterest/view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewWebinarInterest />,
  },

  {
    path: "/add-society-onboard",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <AddSocietyOnboarding />,
  },

  {
    path: "/get-society-onboardings",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <AllSocietyOnbordings />,
  },

  {
    path: "/view-society-onboardings/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <ViewSocietyOnboarding />,
  },

  {
    path: "/edit-society-onboardings/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT,
    ],
    ele: <EditSocietyOnboarding />,
  },

  {
    path: "/add-epg-product",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AddEpgProduct />,
  },

  {
    path: "/all-epg-product",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ProductList />,
  },

  {
    path: "/edit-epg-product/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditEpgProduct />,
  },

  {
    path: "/view-epg-product/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ProductView />,
  },

  {
    path: "/leads-tracking-system",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
    ],
    ele: <LeadsTrackingSystem />,
  },

  {
    path: "/leads/add-new-lead",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <AddNewLeads />,
  },

  {
    path: "/leads/edit-new-lead/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <EditLeadSys />,
  },

  {
    path: "/leads-closer",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
    ],
    ele: <LeadsCloserFunnelSystem />,
  },

  {
    path: `/create-podcast/`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <Addpodcast />,
  },

  {
    path: `/edit-podcast/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <Editpodcast />,
  },

  {
    path: `/podcasts`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <Podcast />,
  },

  {
    path: `/podcasts/view/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewPodcast />,
  },

  {
    path: `/create-reel-short`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddReelShorts />,
  },

  {
    path: `/edit-reel-short/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <EditReelShort />,
  },

  {
    path: `/all-reel-shorts`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <Reelshort />,
  },

  {
    path: `/reel-shorts/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewReelShort />,
  },

  {
    path: `/create-informative-video`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddInformativeVideo />,
  },

  {
    path: `/edit-informative-video/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <EditInformativeVideo />,
  },

  {
    path: `/all-informative-videos`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <InformativeVideos />,
  },

  {
    path: `/informative-video/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewInformativeVideos />,
  },

  {
    path: `/add-graphics`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddGraphics />,
  },

  {
    path: `/edit-graphics/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <EditGraphics />,
  },

  {
    path: `/all-graphics`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <Graphics />,
  },

  {
    path: `/graphics-view/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewGraphics />,
  },
  {
    path: `/add-guest`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddGuestDetails />,
  },

  {
    path: `/edit-guest/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <EditGuestDetails />,
  },

  {
    path: `/guests`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <Guest />,
  },

  {
    path: `/guest-view/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewGuestDetails />,
  },

  {
    path: `/media-content-dashboard`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <MarketingPipelineSystem />,
  },
  {
    path: `/media-posting`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_HR,
    ],
    ele: <Posting_schedules />,
  },

  {
    path: `/creative-standards`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <CreativeStandard />,
  },

  {
    path: `/add-concept-ideas`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddConceptIdeas />,
  },

  {
    path: `/concept-edit/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <EditConceptIdeas />,
  },

  {
    path: `/all-concept-ideas`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ConceptIdeas />,
  },

  {
    path: `/concept-view/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewConceptIdeas />,
  },

  // ---------------Course Topic section---------------

  {
    path: `/create-course`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddCourcedetails />,
  },

  {
    path: `/edit-course/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <EditCourcedetails />,
  },

  {
    path: `/course`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <CourceDetails />,
  },

  {
    path: `/course-view/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_HR,
    ],
    ele: <ViewCourceDetails />,
  },

  // ---------------Course  section---------------

  {
    path: `/get-all-courses`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <CourceNameDetails />,
  },

  {
    path: `/course-name-view/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewCourceNameDetails />,
  },

  {
    path: `/course-name-edit/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <EditCourceNamedetails />,
  },
  {
    path: "/create-enquiry",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <CreateEnquiryForm />,
  },

  {
    path: "/get-justDial-myOperator",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <NewEnquiryData />,
  },

  {
    path: "/create-vendor-buy-order",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALESAGENCY,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <CreateVendorBuyOrderForm />,
  },

  {
    path: "/leads-master",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESAGENCY,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <LeadMasters />,
  },

  {
    path: "/leads-master-view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALLE,
      // process.env.REACT_APP_ROLE_SALLE_ADMIN,
      // process.env.REACT_APP_ROLE_SALESAGENCY,
      // process.env.REACT_APP_ROLE_SALES_MANAGER,
      // process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
    ],
    ele: <ViewLeadMaster />,
  },

  {
    path: "/whatsapp-template",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <WhatsappTemplate />,
  },

  {
    path: "/campaign-stat",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CampaignAllStat />,
  },

  {
    path: `/view-campaign-stat/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CampaignStatView />,
  },

  {
    path: `/whatsapp-template-setting`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <WhatsappTemplateSetting />,
  },

  {
    path: `/view-whatsapp-template-setting/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <ViewWhatsAppTemplateSettingData />,
  },

  {
    path: `/edit-whatsapp-template-setting/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditWhatsAppTemplateDetails />,
  },

  {
    path: `/create-whatsapp-template-setting`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CreateWhatsAppTemplateDetails />,
  },

  {
    path: `/create-schedule`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <AddSchedule />,
  },

  {
    path: `/get-ai-call-log`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <GetAiCallLogs />,
  },

  {
    path: `/get-ai-call-log/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <CallViewPage />,
  },

  {
    path: `/get-ai-bookings`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <GetAiBookings />,
  },

  {
    path: `/get-ai-bookings/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
    ],
    ele: <ViewBookingDetails />,
  },

  {
    path: `/verify-salary`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],
    ele: <SalaryLogin />,
  },

  {
    path: `/add-candidate-details`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <AddCandidateDetails />,
  },
  {
    path: `/update-candidate-details/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <EditCandidateDetails />,
  },

  {
    path: `/view-candidate-details/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <ViewCandidateDetails />,
  },

  {
    path: `/candidates`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <InterviewCandidates />,
  },

  {
    path: `/interview-schedule-pipeline`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <InterviewPipelineSystem />,
  },

  {
    path: `/leads-transfer`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <LeadTransfer />,
  },

  {
    path: `/get-leads-transfer`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <GetTransferLeads />,
  },

  {
    path: `/view-transfer/:id`,
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
    ],
    ele: <ViewTransferDetails />,
  },

  {
    path: "/add-epg-recipe",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AddEpgRecipe />,
  },

  {
    path: "/edit-epg-recipe/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <EditEpgRecipe />,
  },

  {
    path: "/view-epg-recipe/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <RecipeView />,
  },

  {
    path: "/all-epg-recipe",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
    ],
    ele: <AllEpgRecipe />,
  },

  {
    path: "/view-schedules/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],
    ele: <ViewPostSchedule />,
  },

  {
    path: "/add-grn-items",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <AddGRNPurchaseOrder />,
  },

  {
    path: "/edit-grn-items/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <EditGRNPurchaseOrder />,
  },

  {
    path: "/all-grn-items",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <GrnSystem />,
  },

  {
    path: "/view-grn-items/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <ViewGrn />,
  },

  {
    path: "/preview-grn-items/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],
    ele: <GrnPreview />,
  },

  {
    path: "/build-templte",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],

    ele: <PodcastCard />,
  },

  {
    path: "/build-templte-second",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],

    ele: <PodcastGuest2Card />,
  },

  {
    path: "/build-quote-tamplate",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],

    ele: <QuoteCard />,
  },

  {
    path: "/build-crousel-tamplate",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],

    ele: <CrouselNewsCard />,
  },

  {
    path: "/req-for-material/new",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],

    ele: <ADDRequestForMaterial />,
  },

  {
    path: "/req-for-material/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],

    ele: <EditRequestForMaterial />,
  },

  {
    path: "/req-for-material",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],

    ele: <RFM />,
  },

  {
    path: "/view-req-for-material/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_SALLE,
      process.env.REACT_APP_ROLE_SALLE_ADMIN,
      process.env.REACT_APP_ROLE_AGRONOMIST,
      process.env.REACT_APP_ROLE_OPS,
      process.env.REACT_APP_ROLE_INSPECTION,
      process.env.REACT_APP_ROLE_MARKETING,
      process.env.REACT_APP_ROLE_IT,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_SALES_MANAGER,
      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK,
      process.env.REACT_APP_ROLE_HR,
      process.env.REACT_APP_ROLE_JR_HR,
      process.env.REACT_APP_ROLE_SALESCOORDINATOR,
      process.env.REACT_APP_ROLE_OFFICE_STAFF,
    ],

    ele: <ViewRFM />,
  },

  {
    path: "/media-task-assign",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
    ],

    ele: <CreateMarketingDeliveryTask />,
  },

  {
    path: "/media-task-update/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_MARKETING_AGENCY,
    ],

    ele: <EditMarketingDeliveryTask />,
  },

  {
    path: "/get-all-media-task",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_MARKETING_AGENCY,
    ],

    ele: <MediaDelivery />,
  },

  {
    path: "/media-task-view/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_MARKETING_AGENCY,
    ],

    ele: <ViewTaskDetails />,
  },
  {
    path: "/alpha-call-tracking",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_SSM,
      process.env.REACT_APP_ROLE_MARKETING_AGENCY,
    ],

    ele: <AlphaCallTracking />,
  },

  {
    path: "/Po-Grn-Vendor-Payment",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],

    ele: <PoExtraPayment />,
  },

  {
    path: "/Po-Grn-Vendor-Payment/View/:id",
    roles: [
      process.env.REACT_APP_ROLE_ADMIN_S,
      process.env.REACT_APP_ROLE_ADMIN,
      process.env.REACT_APP_ROLE_PURCHASE,
      process.env.REACT_APP_ROLE_ACCOUNTS,
    ],

    ele: <ViewPoGrnPaymentDetails />,
  },

];

export default function AllRoutes() {
  let role = useSelector((store) => store?.login?.user?.Role);
  const loginState = useSelector((state) => state.login);
  const filteredRoutes = routes.filter((route) => route.roles.includes(role));

  return (
    <Routes>
      {filteredRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={<PrivateRoutes>{route.ele}</PrivateRoutes>}
        />
      ))}
      <Route
        path="/account-setting"
        element={
          <PrivateRoutes>
            <UserAccountSetting />
          </PrivateRoutes>
        }
      />

      <Route path="/account-login" element={<UserLogin />} />
      <Route path="/forgot-password" element={<ForgetPassword />} />
      <Route
        path="/reset-password"
        element={
          <PrivateRoutes>
            <ResetPassword />
          </PrivateRoutes>
        }
      />

      <Route path="/warranty" element={<WarrantyPdfPage />} />
      <Route path="/si-feedback" element={<SIFeedback />} />
      <Route path="/terms&conditions" element={<TermsAndConditions />} />
      <Route path="/contact_us" element={<ContactUs />} />
      <Route path="/privacy_policy" element={<PrivacyPolicy />} />
      <Route path="/hm-webinar-order/:id" element={<WebinarNewForm />} />
      <Route path="/webinar-payment-success" element={<Paymentsuccess />} />
      <Route path="/webinar-payment-failed" element={<Paymentfailure />} />
      <Route path="/client-enquiry" element={<EnquiryForm />} />
      <Route path="/pricing" element={<Pricing />} />
      {/* <Route path="/view-match/:id" element={<ViewcricketMatch />} />
       */}
      <Route
        path="/email-anlaytics/:encodedEmail"
        element={<EmailAnlaytics />}
      />

      <Route
        path="/unsubscribe-mail/:emailEncoded"
        element={<UnsubscribeMail />}
      />
      <Route
        path="/view-quotation/:emailEncoded"
        element={<PublicQuotation />}
      />

      <Route path="/" element={<Home />} />
      <Route path="/request-refund" element={<ReqRefund />} />
      <Route
        path="/schedule-site-inspection/:id"
        element={<SIschedulesByClient />}
      />
      <Route
        path="/edit-schedule-site-inspection/:id"
        element={<EditSIschedulesByClient />}
      />
      <Route
        path="/cancel-schedule-site-inspection/:id"
        element={<CancelSiSchedules />}
      />
      <Route
        path="/hm-webinar-home"
        element={<WebinarHomeRedirect></WebinarHomeRedirect>}
      />
      <Route
        path="/hydroponic-webinar"
        element={<Webinarhomepage></Webinarhomepage>}
      />
      <Route
        path="/add-webinar-feedback/:id"
        element={<CreateWebinarFeedback />}
      />
      {loginState?.isLoggedIn ? (
        <Route path="*" element={<Dashbourd />} />
      ) : (
        <Route path="*" element={<Home />} />
      )}
      <Route
        path="/update-new-password/:email/:time"
        element={<UpdatePassword />}
      />
      <Route path="/expired-link" element={<ExpiredlinkPage />} />
      <Route path="/webinar-live/:id" element={<LiveStreamPage />} />
      <Route path="/agri-subsidy/" element={<AgriSubsidy />} />
      <Route
        path="nhm-government-subsidy/:state/:city"
        element={<NHMSubsidy />}
      />
      <Route
        path="nhb-government-subsidy/:state/:city"
        element={<NHBSubsidy />}
      />
      <Route
        path="aif-government-subsidy/:state/:city"
        element={<AIFSubsidy />}
      />

      <Route
        path="hydroponic-farm-construction/:state/:city"
        element={<HydroponicFarmConstruction />}
      />

      <Route
        path="polyhouse-farm-construction/:state/:city"
        element={<PolyhouseConstruction />}
      />

      <Route path="/career" element={<ApplicationForm />} />
      <Route
        path="/kryzen-naturally-ventilated-polyhouse"
        element={<NaturallyVentilatedPolyhouse />}
      />
      <Route path="/kryzen-nethouse-shadehouse" element={<NetHouse />} />
      <Route
        path="/kryzen-exhaust-fan-pad-controlled-environment-polyhouse"
        element={<Fanpad />}
      />
      <Route path="/kryzen-flat-nft-hydroponics" element={<FlatBed />} />
      <Route path="/kryzen-dutch-buckets" element={<DutchBucket />} />
      <Route path="/kryzen-for-soil-less-growing" element={<GrowBags />} />
      <Route path="/why-kryzen-biotech" element={<WhyKryzenBiotech />} />
      <Route path="/kryzen-software-services" element={<SoftwareServices />} />
      <Route
        path="/kryzen-agronomy-support"
        element={<AgronomySupportPublic />}
      />
      <Route path="/kryzen-employee-tranning" element={<EmployeeProgram />} />
      <Route path="/kryzen-a-frame" element={<AFrame />} />
      <Route path="/kryzen-growslab" element={<GrowSlab />} />
      <Route path="/kryzen-quotation-explainer" element={<QuotationnEx />} />
      <Route path="/refund-policy" element={<Refundpolicy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyNew />} />
      <Route path="/terms-condition" element={<TermsAndConditionsPolicy />} />
      <Route path="/order-cea-kit" element={<AgriPurchase />} />
      <Route
        path="/site-inspection-information"
        element={<SiteinspectionInfo />}
      />
      <Route
        path="polyhouse-construction-layout/:length/:width"
        element={<Polyhouseseopages />}
      />
      <Route path="webinar-uuid/:uuidtoken" element={<WebinarFallbackPage />} />
      <Route
        path="/check-your-eligibility/:maskNhmNumber"
        element={<ViewEligibleFarmer />}
      />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/aif-extended-date" element={<PdfAutoDownload />} />
    </Routes>
  );
}
